import { branchActions } from '../ActionTypes';
import { updateState } from '../../middlewares/utils';

const initialFormData = {
  Id: '0',
  Name: '',
  State: '',
  Country: ''
};

const defaultState = {
  branchList: [],
  tableLoading: false,
  form: initialFormData,
  formLoading: false,
  formError: null,
  deleteId: null
};


export default (state = defaultState, actions) => {
  switch (actions.type) {
    case branchActions.BRANCH_FETCH_START:
      return updateState(state, { tableLoading: true });
    case branchActions.BRANCH_FETCH_SUCCESS:
      return updateState(state, { tableLoading: false, branchList: actions.payload });
    case branchActions.BRANCH_FETCH_ERROR:
      return updateState(state, { tableLoading: false, ...actions.payload });
    case branchActions.BRANCH_SAVE_START:
      return updateState(state, { formLoading: true, formError: null, form: initialFormData });
    case branchActions.BRANCH_SAVE_SUCCESS:
      return updateState(state, { formLoading: false, form: initialFormData });
    case branchActions.BRANCH_SAVE_FAILED:
      return updateState(state, { formLoading: false, ...actions.payload });
    case branchActions.BRANCH_SET_FORM:
      return updateState(state, { ...actions.payload, formError: null });
    case branchActions.BRANCH_RESET_FORM:
      return updateState(state, { form: initialFormData });
    default:
      return state;
  }
};
